module.exports = "<svg viewBox=\"0 0 50 50\"><line x1=\"4\" y1=\"4\" x2=\"46\" y2=\"46\"></line><line x1=\"46\" y1=\"4\" x2=\"4\" y2=\"46\"></line></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphcool-styles/icons/stroke/cross.svg
// module id = 227
// module chunks = 0 1